'use strict';

export function parse(url) {
  let qs = {};

  const idx = url.indexOf('?');
  if(idx > -1) {
    qs = url
      .slice(idx+1)
      .split('&')
      .reduce((map, kv) => {
        const parts = kv.split('=');
        if(parts.length === 2) {
          map[parts[0]] = parts[1];
        }
        return map;
      }, {});
  }

  return qs;
}


// WEBPACK FOOTER //
// ./src/common/qs.js